import { Invoice, InvoiceDetail, InvoiceSummaryWithCustomerJobData } from '../../../domain/invoicing/invoice'
import { CustomerEmail, getBestCustomerEmail } from '../../../domain/customers/customer'
import { SendInvoiceRequest } from '../../../domain/invoicing/invoicingApi'

export const pickInitialEmail = (
  invoiceSummary: InvoiceSummaryWithCustomerJobData | null,
  details: InvoiceDetail | undefined,
  customerEmails: CustomerEmail[] | undefined,
): string => {
  if (!invoiceSummary) {
    return ''
  }
  const isSynkedUP = invoiceSummary.invoicingSystem === 'synkedUp'
  const qbEmail = details?.quickBooksInvoice?.emailAddress ?? ''
  const customerEmail = getBestCustomerEmail(customerEmails ?? []) ?? ''
  if (isSynkedUP) {
    return customerEmail
  }
  return qbEmail || customerEmail
}

export const buildSendInvoiceRequest = (
  invoiceSummary: InvoiceSummaryWithCustomerJobData,
  invoice: Invoice,
  email: string,
): SendInvoiceRequest => ({
  invoiceId: invoiceSummary.invoiceId,
  emailAddresses: [email],
  invoiceUpdates: {
    dueOn: invoice.dueOn || undefined,
    enableCreditCardPayments: invoice.enableCreditCardPayments,
    enableAchPayments: invoice.enableAchPayments,
    showAuthorizePaymentOnFile: invoice.showAuthorizePaymentOnFile,
    requireAuthorizePaymentOnFile: invoice.requireAuthorizePaymentOnFile,
  },
})

type SubmitDisabledArgs = {
  isLoading: boolean
  email: string
  isSynkedUP: boolean
  invoice: Invoice | undefined
}

export const isEmailInvoiceSubmitDisabled = ({ isLoading, email, isSynkedUP, invoice }: SubmitDisabledArgs): boolean => {
  return isLoading || email.trim().length === 0 || (isSynkedUP && !invoice)
}
